export function AccountsHeader() {
  return (
    <div className="mb-10 text-center sm:text-left">
      <h2 className="text-[40px] font-bold tracking-tight text-foreground">
        Cuentas
      </h2>
      <p className="text-gray text-lg font-medium mt-1">
        Gestiona todas las sub-cuentas con precisión quirúrgica.
      </p>
    </div>
  );
}
